import { PaymentMethod } from "enums";
import { prettifyPaymentMethod } from "utils/pretty.utils";

export const nonCashAdjustmentPaymentMethods = [
  PaymentMethod.Card,
  PaymentMethod.GiftCard,
  PaymentMethod.VIP,
  PaymentMethod.GCash,
  PaymentMethod.Maya,
  PaymentMethod.BDOCredit,
  PaymentMethod.BDODebit,
  PaymentMethod.BDOFleet,
  PaymentMethod.Duplicate,
  PaymentMethod.DriveOff,
  PaymentMethod.Loa,
  PaymentMethod.Misfill,
  PaymentMethod.PLCLiter,
  PaymentMethod.PLCLocqpay,
  PaymentMethod.PLBFleetCard,
  PaymentMethod.PLBManualPO,
  PaymentMethod.PLBFuelCode,
  PaymentMethod.PLCLubes,
  PaymentMethod.PLBLubes,
  PaymentMethod.KeyAccount,
  PaymentMethod.QRPH,
];

export const lubesOnlyAdjustmentPaymentMethods = [PaymentMethod.PLCLubes, PaymentMethod.PLBLubes];

export const fuelOnlyAdjustmentPaymentMethods = [
  PaymentMethod.PLCLiter,
  PaymentMethod.PLCLocqpay,
  PaymentMethod.PLBFleetCard,
  PaymentMethod.PLBManualPO,
  PaymentMethod.PLBFuelCode,
];

export const adjustmentPaymentMethods = [PaymentMethod.Cash, ...nonCashAdjustmentPaymentMethods];

export const adjustmentPaymentMethodOptions = adjustmentPaymentMethods.map((value) => ({
  label: prettifyPaymentMethod(value),
  value,
}));

export const isNonCashAdjustmentPaymentMethod = (method) =>
  Boolean(method) && method !== PaymentMethod.Cash;

export const resolveAdjustmentPaymentMethod = (method) => {
  if (!method) return "";
  if (adjustmentPaymentMethods.includes(method)) return method;

  const label = prettifyPaymentMethod(method);
  return adjustmentPaymentMethods.find((value) => prettifyPaymentMethod(value) === label) ?? "";
};
